import { useMemo } from 'react';
import { OmniIconButton } from './';

const providerOverrides: Record<string, { name: string; icon: string }> = {
  auth0: {
    name: 'Auth0',
    icon: 'bi:door-open'
  },
  azure_oauth2: {
    name: 'Microsoft',
    icon: 'bi:microsoft'
  },
  developer: {
    name: 'Developer',
    icon: 'bi:code-square'
  },
  google_oauth2: {
    name: 'Google',
    icon: 'flat-color-icons:google'
  },
  github_oauth2: {
    name: 'GitHub',
    icon: 'bi:github'
  }
};

interface OmniAuthButtonProps {
  provider: string;
  providerPath: string;
  params?: Record<string, string>;
  [key: string]: unknown;
}

export const OmniAuthButton = ({
  provider,
  providerPath,
  params = {},
  ...props
}: OmniAuthButtonProps) => {
  const endpoint = useMemo(() => {
    const search = new URLSearchParams(params).toString();
    return search ? `${providerPath}?${search}` : providerPath;
  }, [providerPath, params]);

  // The icon falls back to the provider name unless an override supplies one.
  const override = providerOverrides?.[provider];

  return (
    <OmniIconButton
      endpoint={endpoint}
      icon={override?.icon ?? provider}
      name={override?.name}
      {...props}
    />
  );
};
